import local from "../continue/local";
export default class index {
    constructor() {
        this.localSta = new local();
    }
    callBack = (That,replace=false) =>{
        let url = this.localSta.get('CallBackUrl');
        if(url == '' || url == 'null' || url == null || url.indexOf('null') !== -1){
            url = '/'
        }
        if(replace){
            That.$router.replace({
                path:url
            });
        }else{
            That.$router.push({
                path:url
            });
        }
        this.localSta.remove('CallBackUrl')
    }

    setCallBack = (url) =>{
        this.localSta.set('CallBackUrl', url)
    }

    setPageBack = (url,title) =>{
        this.localSta.set(title+'PageBackUrl', url)
    }
}


// WEBPACK FOOTER //
// ./src/controller/route/index.js